import queryString from 'query-string';
import get from 'lodash/get';

import fetchQuery from 'rebook/apps/utils/fetchQuery';
import {
  CATALOG_BOOK_LIST_SET_DATA,
  CATALOG_BOOK_LIST_RESET_DATA,
  GET_SEO_META,
} from 'rebook/apps/catalog/constants';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import getPageNumberString from 'rebook/apps/utils/text/getPageNumberString';


export function fetchInitialData(match, location={}) {
  return async(dispatch, getState) => {
    const { ssr, catalogBookList: currentState } = getState();
    let getParams = get(location, 'search', null);
    getParams = queryString.parse(getParams);
    const pageNumber = parseInt(get(ssr, 'query.page', 1), 10);
    const orderBy = get(ssr, 'query.o', 'popular');
    const subscriptionId = get(ssr, 'query.s', null) || get(getParams, 's', null);
    const bookType = get(ssr, 'query.t', null);
    const booksListType = get(match, 'params.bookType', null);
    const prevBooksListType = get(currentState, 'match.params.bookType', null);

    let newState = {
      match,
      pageNumber,
      orderBy,
      subscriptionId,
      bookType,
    };

    if (location && location.state) {
      newState = {
        ...newState,
        ...location.state,
      };
    }

    if (currentState.books) {
      newState = {
        ...newState,
        ...currentState,
      };
    }
    dispatch(setData(newState));

    dispatch(setSeoMeta(match, pageNumber));

    if (!newState.books || currentState.pageNumber !== pageNumber || (prevBooksListType !== booksListType)) {
      await dispatch(fetchBookList(newState, match));
    }
  };
}

export function fetchBookList(params = {}, match) {
  return async(dispatch, getState) => {
    const catalogBookType = get(match, 'params.bookType', '');
    const areBooksFree = catalogBookType === 'free';
    const areBooksAudio = catalogBookType === 'audio';
    const { ssr, catalogBookList } = getState();
    const mergedState = Object.assign({}, catalogBookList, params);
    const { paginateBy, orderBy, subscriptionId, bookType } = mergedState;
    let pageNumber = mergedState.pageNumber;

    if (!params.pageNumber &&
      (catalogBookList.subscriptionId !== mergedState.subscriptionId)
      || (catalogBookList.bookType !== mergedState.bookType)
    ) {
      pageNumber = 1;
    }

    let queryParams = {
      offset: (pageNumber - 1) * paginateBy,
      limit: paginateBy,
      o: orderBy,
      author_weight__gte: 0,
      ...(subscriptionId!==null && {
        subscription_id__in: subscriptionId,
      }),
      ...(bookType!==null && {
        type: bookType,
      }),
    };

    if (areBooksFree) {
      queryParams['subscription_id__in'] = 0;
    }
    if (areBooksAudio) {
      queryParams['type'] = 'audio';
      queryParams['subscription_id__in'] = null;
    }
    const qs = queryString.stringify(queryParams);
    const url = `/api/books/?${qs}`;

    let pendingState = {
      // clear the book list before the fetch
      books: null,
      // optimistically update the UI
      pageNumber: pageNumber,
      orderBy,
      lastPageNumber: 0,
      ...(subscriptionId!==null && { subscriptionId }),
      ...(bookType!==null && { bookType }),
    };
    dispatch(setData(pendingState));

    return (
      fetchQuery(url, { apiVersion: 4, headers: ssr.headers })
        .then(
          ({ data }) => {
            const lastPageNumber = Math.ceil(data.meta.total_count / paginateBy);
            dispatch(setData({
              books: data.objects,
              lastPageNumber: lastPageNumber,
              totalBookCount: data.meta.total_count,
              orderBy,
              subscriptionId,
              bookType,
            }));
          }
        )
        .catch(
          ({ data, resp, error }) => {
            Raven.captureMessage('failed to load author books due to server error', {
              level: 'error',
              extra: {
                status: resp.status,
                response: data,
                error,
              },
            });
            throw new Error('failed to load author books due to server error');
          }
        )
    );
  };
}

export function setSeoMeta(match, pageNumber) {
  return (dispatch, getState) => {
    const { bookType } = match.params;
    const audioBooksCounter = getState().booksPerSubscriptionCounter.audio;
    const bookTypeMapper = [
      'free',
      'audio',
    ];
    let title = `${GET_SEO_META(bookType)
      ? GET_SEO_META(bookType, audioBooksCounter).title
      : GET_SEO_META('byDefault', audioBooksCounter).title}`;
    let description = `${GET_SEO_META(bookType, audioBooksCounter)
      ? GET_SEO_META(bookType, audioBooksCounter).description
      : GET_SEO_META('byDefault', audioBooksCounter).description}`;
    title = `${title} ${getPageNumberString(pageNumber)}`.trim();
    description = `${description}`;

    const defaultUrl = `https://${BASE_HOST}/catalog/books/`;
    const noRobots = pageNumber > 1;
    const canonicalUrl = bookTypeMapper.includes(bookType) ? `${defaultUrl}${bookType}/` : defaultUrl;
    dispatch(SeoActions.setData({
      robots: noRobots ? 'noindex, nofollow' : null,
      canonicalUrl,
      title,
      description,
      pageNumber,
    }));
  };
}

export function setData(payload) {
  return (dispatch) => {
    dispatch({
      type: CATALOG_BOOK_LIST_SET_DATA,
      payload,
    });
  };
}

export function resetData() {
  return (dispatch) => {
    dispatch({
      type: CATALOG_BOOK_LIST_RESET_DATA,
    });
    dispatch(SeoActions.resetData());
  };
}
